import { CreditCard, Loader2 } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useBillingSession } from "@/lib/billing-session";

/**
 * Proactive guidance for a company that has not subscribed yet (`unpaid_setup`), shown before
 * anyone tries a restricted action. Trial and free-grant companies never see it.
 */
export function SubscriptionSetupNotice({ canManageBilling }: { canManageBilling: boolean }) {
  const billing = useBillingSession();
  return (
    <Alert variant="warning" role="status">
      <CreditCard aria-hidden="true" />
      <AlertTitle>Set up your subscription to start working</AlertTitle>
      <AlertDescription className="flex flex-col gap-3 text-foreground sm:flex-row sm:items-center sm:justify-between">
        <span>
          {canManageBilling
            ? "Your company is ready. Creating projects, uploading, and processing documents start once you subscribe."
            : "Your company hasn't subscribed yet. Ask your organization owner or admin to set up billing."}
        </span>
        {canManageBilling && (
          <Button
            className="shrink-0"
            onClick={() => void billing.open()}
            disabled={billing.pendingIntent !== null}
          >
            {billing.pendingIntent !== null && <Loader2 className="size-4 animate-spin" />}
            Set up billing
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
}
